import React, { useState } from 'react';
import axios from 'axios';
import './DLVerificationForm.css';

const DLVerificationForm = () => {
  const [formData, setFormData] = useState({
    customer_dl_number: '',
    customer_dob: '',
    name_to_match: '',
    consent: 'Y',
    consent_text: 'I hereby give my consent for DL verification.'
  });

  const [responseData, setResponseData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Replace with actual credentials or load securely
    const APP_ID = process.env.REACT_APP_BACKEND_APPID;
    const API_KEY = process.env.REACT_APP_BACKEND_APIKEY;

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const res = await axios.post(
        'https://digilocker.myearth.id/api/drivinglicense/verify-dl',
        formData,
        {
          headers: {
            'app-id': APP_ID,
            'x-api-key': API_KEY,
          },
        }
      );
      setResponseData(res.data);
    } catch (err) {
      setError(err.response?.data || 'An error occurred');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dl-container">
      <div className="form-section">
        <h2>DL Verification</h2>
        <form onSubmit={handleSubmit}>
          <label>Driving License Number</label>
          <input
            type="text"
            name="customer_dl_number"
            value={formData.customer_dl_number}
            onChange={handleChange}
            required
          />
          <label>Date of Birth (DD-MM-YYYY)</label>
          <input
            type="text"
            name="customer_dob"
            value={formData.customer_dob}
            onChange={handleChange}
            required
          />
          <label>Name (Optional)</label>
          <input
            type="text"
            name="name_to_match"
            value={formData.name_to_match}
            onChange={handleChange}
          />
          <label>Consent</label>
          <input
            type="text"
            name="consent"
            value={formData.consent}
            onChange={handleChange}
            required
          />
          <label>Consent Text</label>
          <textarea
            name="consent_text"
            value={formData.consent_text}
            onChange={handleChange}
            rows="3"
            required
          />
          <button type="submit" disabled={loading}>
            {loading ? 'Verifying...' : 'Submit'}
          </button>
        </form>
      </div>

      <div className="response-section">
        <h2>API Response</h2>
        {error && <pre className="error-box">{JSON.stringify(error, null, 2)}</pre>}
        {responseData && <pre className="response-box">{JSON.stringify(responseData, null, 2)}</pre>}
        {!responseData && !error && <p className="placeholder">Submit the form to see the response here.</p>}
      </div>
    </div>
  );
};

export default DLVerificationForm;
